import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.1 16.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.6 16.2c.4 0 .8-.1 1.1-.4s.4-.7.4-1.1V3.5c0-.4-.1-.8-.4-1.1S13 2 12.6 2h-1.5V.4c0-.1 0-.2-.1-.3s-.2-.1-.3-.1h-.3c-.1 0-.2 0-.3.1s-.1.2-.1.3V2H4V.4c0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.1h-.3c-.1 0-.2 0-.3.1S3 .3 3 .4V2H1.5c-.4 0-.8.1-1.1.4S0 3.1 0 3.5v11.1c0 .4.1.8.4 1.1s.7.4 1.1.4h11.1zm.5-11.1H1V3.6c0-.1 0-.3.1-.4s.2-.1.4-.1h11.1c.1 0 .3 0 .4.1s.1.2.1.4zm-.5 10.1H1.5c-.1 0-.3 0-.4-.1s-.1-.2-.1-.4V6.1h12.1v8.6c0 .1 0 .3-.1.4s-.2.1-.4.1m-5.4-1.6c.1 0 .2 0 .3-.1s.1-.2.1-.3v-2.1h2.1c.1 0 .2 0 .3-.1s.1-.2.1-.3v-.3c0-.1 0-.2-.1-.3s-.2-.1-.3-.1H7.6V8c0-.1 0-.2-.1-.3s-.2-.1-.3-.1h-.3c-.1 0-.2 0-.3.1s-.1.2-.1.3v2.1H4.4c-.1 0-.2 0-.3.1s-.1.2-.1.3v.3c0 .1 0 .2.1.3s.2.1.3.1h2.1v2.1c0 .1 0 .2.1.3s.2.1.3.1h.3z"
    }, null, -1)
  ]))]))
}
export default { render: render }